import { LoaderFunctionArgs, redirect } from 'react-router-dom';
import { verifyInvitation } from '@/portal/api/PortalInvitations.ts';
import VerifyInvitationPage from '@/portal/routes/verify-invitation/Page.tsx';

export async function loader({ request }: LoaderFunctionArgs) {
  const url = new URL(request.url);
  const token = url.searchParams.get('token');

  if (!token) {
    throw new Response('Missing token', { status: 400 });
  }

  const data = await verifyInvitation(token);
  sessionStorage.setItem('verified_email', data.email);

  return redirect('/portal/registration');
}

export default function VerifyInvitationRoute() {
  return <VerifyInvitationPage />;
}
